import React from 'react';
type StatusType = 'Pending' | 'Processing' | 'TitleFetchInitiated' | 'TitleFetchCompleted' | 'ApprovalPending' | 'PaymentInitiated' | 'PartiallyCompleted' | 'Completed' | 'Approved' | 'Rejected' | 'Failed' | 'Active' | 'Inactive' | 'Locked';
interface StatusBadgeProps {
  status: string;
  size?: 'sm' | 'md';
}
export function StatusBadge({
  status,
  size = 'md'
}: StatusBadgeProps) {
  const getStatusColor = (status: string) => {
    switch (status) {
      case 'Pending':
      case 'Inactive':
        return 'bg-gray-100 text-gray-800 border-gray-200';
      case 'Processing':
      case 'TitleFetchInitiated':
      case 'TitleFetchCompleted':
      case 'PaymentInitiated':
        return 'bg-blue-100 text-blue-800 border-blue-200';
      case 'ApprovalPending':
      case 'PartiallyCompleted':
        return 'bg-amber-100 text-amber-800 border-amber-200';
      case 'Completed':
      case 'Approved':
      case 'Active':
        return 'bg-emerald-100 text-emerald-800 border-emerald-200';
      case 'Rejected':
      case 'Failed':
      case 'Locked':
        return 'bg-red-100 text-red-800 border-red-200';
      default:
        return 'bg-gray-100 text-gray-800 border-gray-200';
    }
  };
  const sizeClasses = size === 'sm' ? 'px-2 py-0.5 text-xs' : 'px-2.5 py-0.5 text-sm';
  // Format the status string (camelCase to Title Case)
  const formattedStatus = status.replace(/([A-Z])/g, ' $1').trim();
  return <span className={`inline-flex items-center rounded-full border font-medium ${getStatusColor(status)} ${sizeClasses}`} data-id="element-149">
      <span className={`w-1.5 h-1.5 rounded-full mr-1.5 ${status === 'Pending' ? 'bg-gray-400' : status === 'Rejected' || status === 'Failed' ? 'bg-red-400' : status.includes('Pending') ? 'bg-amber-400' : 'bg-current'}`} data-id="element-150"></span>
      {formattedStatus}
    </span>;
}